<template>
	<div class="animated fadeIn">
		<div class="table-responsive">
			<table class="table table-hover table-striped text-nowrap">
				<thead>
					<tr>
						<th
							class="border-top-0 text-left">
							{{ translate('period') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('subtotal') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('other_method_paid') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('shipping') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('duties') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('total_sales') }}
						</th>
						<!--<th
							class="border-top-0 text-right">
							{{ translate('refunds') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('expenses') }}
						</th>
						<th
							class="border-top-0 text-right">
							{{ translate('net_sales') }}
						</th>-->
					</tr>
				</thead>
				<tbody v-if="!loading && hasData">
					<tr
						v-for="(item, index) in data"
						:key="index">
						<td class="text-left text-capitalize">
							{{ periodInfo(item.attributes.group, responseType) }}
						</td>
						<td class="text-right">
							{{ item.attributes.subtotal }}
						</td>
						<td class="text-right">
							{{ item.attributes.split_payment_paid }}
						</td>
						<td class="text-right">
							{{ item.attributes.shipping }}
						</td>
						<td class="text-right">
							{{ item.attributes.tax }}
						</td>
						<td class="text-right">
							{{ item.attributes.total }}
						</td>
						<!--<td class="text-right">
							{{ item.attributes.refund }}
						</td>
						<td class="text-right">
							{{ item.attributes.expenses }}
						</td>
						<td class="text-right">
							{{ item.attributes.net_sales }}
						</td>-->
					</tr>
					<tr class="text-right">
						<td>
							<b />
						</td>
						<td class="text-right">
							<b>{{ totals.subtotal }}</b>
						</td>
						<td class="text-right">
							<b>{{ totals.split_payment_paid }}</b>
						</td>
						<td class="text-right">
							<b>{{ totals.shipping }}</b>
						</td>
						<td class="text-right">
							<b>{{ totals.tax }}</b>
						</td>
						<td class="text-right">
							<b>{{ totals.total }}</b>
						</td>
						<!--<td class="text-right">
							<b>{{ totals.refund }}</b>
						</td>
						<td class="text-right">
							<b>{{ totals.expenses }}</b>
						</td>
						<td class="text-right">
							<b>{{ totals.net_sales }}</b>
						</td>-->
					</tr>
				</tbody>
			</table>
		</div>
		<is-loading
			:loading-label="translate('loading')"
			:no-data-label="translate('data_not_found')"
			:loading="loading"
			:has-data="hasData" />
		<b-pagination
			v-if="pagination.total_pages > 1"
			v-model="pagination.current_page"
			:total-rows="pagination.total"
			:per-page="pagination.per_page"
			align="center"
			@change="getDataFiltered" />
	</div>
</template>
<script>
import { PAGINATION } from '@/settings/RequestReply';
import {
	Report as messages, Grids, PaymentMethods, Countries,
} from '@/translations';
import FiltersParams from '@/mixins/FiltersParams';
import {
	MD_FORMAT as mdFormat,
	MY_FORMAT as myFormat,
	MDY_FORMAT as mdyFormat,
	YEAR_FORMAT as yFormat,
} from '@/settings/Dates';
import Sales from '@/util/Report';

export default {
	name: 'SalesPeriods',
	messages: [messages, Grids, PaymentMethods, Countries],
	mixins: [FiltersParams],
	data() {
		return {
			salesPeriods: new Sales(),
		};
	},
	computed: {
		loading() {
			return !!this.salesPeriods.data.loading;
		},
		errors() {
			return this.salesPeriods.data.errors;
		},
		pagination() {
			return this.salesPeriods.data.pagination;
		},
		data() {
			try {
				const { data } = this.salesPeriods.data.response.data;
				return data;
			} catch (error) {
				return [];
			}
		},
		responseType() {
			try {
				return this.salesPeriods.data.response.data.meta.type;
			} catch (error) {
				return 'custom';
			}
		},
		hasData() {
			return !!this.data.length;
		},
		totals() {
			try {
				const { totals } = this.salesPeriods.data.response.data.meta;
				return totals;
			} catch (error) {
				return {};
			}
		},
	},
	mounted() {
		this.$parent.$parent.rangeStart = '';
		this.$parent.$parent.rangeEnd = '';
		this.salesPeriods.getSalesByPeriod().then(() => {
			const { start, end } = this.salesPeriods.data.response.data.meta.period_dates;
			this.$parent.$parent.rangeStart = this.$moment(start.date).format(mdyFormat);
			this.$parent.$parent.rangeEnd = this.$moment(end.date).format(mdyFormat);
		});
	},
	methods: {
		getDataFiltered(page) {
			if (typeof page === 'object') {
				this.filters = { ...this.filters, ...page };
			}
			const { query } = this.$route;
			const options = { ...query, ...this.filters };
			if (typeof page === 'number') {
				options[PAGINATION] = page;
			}
			this.salesPeriods.getSalesByPeriod(options);
		},
		periodInfo(group, type) {
			try {
				if (type === 'hours') {
					return this.translate(group);
				}
				if (type === 'custom') {
					return this.translate(group);
				}
				if (type === 'months') {
					return this.$moment(group.date).format(myFormat);
				}
				if (type === 'days') {
					return this.$moment(group.date).format(mdFormat);
				}
				if (type === 'weeks') {
					return `${this.$moment(group.start.date).format(mdFormat)} - ${this.$moment(group.end.date).format(mdFormat)}`;
				}
				if (type === 'years') {
					return this.$moment(group.date).format(yFormat);
				}
				if (type === 'weekly_year') {
					return `${this.$moment(group.start.date).format(mdyFormat)} - ${this.$moment(group.end.date).format(mdyFormat)}`;
				}
			} catch (error) {
				return '';
			}
			return '';
		},
	},
};
</script>
